import { Modal } from "@material-ui/core";
import React, { memo, useEffect, useState } from "react";
import AddClientInnerModal from "../add-client-inner-modal/AddClientInnerModal";
import { useStylesAddClientModal } from "./useStylesAddClientModal";

type propsType = {
  isOpen: boolean,
  setCloseModal: () => void
}

const AddClientModal: React.FC<propsType> = (props) => {
  const classes = useStylesAddClientModal()
  const [openModal, setOpenModal] = useState(props.isOpen)

  useEffect(() => {
    setOpenModal(props.isOpen)
  }, [props.isOpen])

  const handleClose = () => {
    setOpenModal((prev) => !prev)
    props.setCloseModal()
  }

  return (
    <Modal
      className={classes.container}
      open={openModal}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className={classes.paper}>
        <AddClientInnerModal
          handleFinishClientAdding={() => handleClose()}
          isClientsPage />
      </div>
    </Modal>
  )
}

export default memo(AddClientModal)